import { AppFormItem, AppFormItemProps, AppBaseSelect, AppBaseSelectProps } from 'components/atoms';
import { SelectOptionType, VatReleaseReason } from 'types';
import { settlementVatReleaseReasonLabels } from 'consts/settlementVatRates/settlementVatReleaseReasonLabels';

type VatReleaseReasonPickerElementProps = AppFormItemProps & Pick<AppBaseSelectProps, 'allowClear'>;

const options: SelectOptionType<VatReleaseReason>[] = [
    {
        label: settlementVatReleaseReasonLabels.ART_43_1,
        value: VatReleaseReason.ART_43_1,
    },

    {
        label: settlementVatReleaseReasonLabels.ART_82_3,
        value: VatReleaseReason.ART_82_3,
    },
    {
        label: settlementVatReleaseReasonLabels.ART_113_1_9,
        value: VatReleaseReason.ART_113_1_9,
    },
    {
        label: settlementVatReleaseReasonLabels.CUSTOM,
        value: VatReleaseReason.CUSTOM,
    },
];

export const VatReleaseReasonPickerElement = ({
    allowClear,
    disabled,
    ...props
}: VatReleaseReasonPickerElementProps) => (
    <AppFormItem disabled={disabled} {...props}>
        <AppBaseSelect options={options} disabled={disabled} allowClear={allowClear} />
    </AppFormItem>
);
